class AdSortableLayer {

    constructor($rootScope) {
        
        this.$rootScope = $rootScope;

        let _self = this;

        return {
            restrict: 'A',
            scope: {
                "adunit": "=adUnit",
                "canvas": "=adSortableLayer"
            },
            link: ($scope, $el, $attr) => {

                $el.sortable({
                    connectWith: ".layer-sorter",
                    items: '.layer-item',
                    stop: ( event, ui ) => {

                        let canvasId = $(event.target).parent().attr("data-canvasid");
                        let layerOrder = [];
                        let canvas, liEl;

                        if(canvasId == $scope.canvas.id) {
                            liEl = $el;
                            canvas = $scope.canvas;
                        }
                        else {
                            liEl = $(event.target).parent();
                            canvas = $scope.adunit.canvas.layers.find(x => x.id == canvasId);
                        }
                        
                        $("li", liEl).each( (ix, el) => {
                            let layerId = $(el).attr("data-layerid");
                            let layer = $scope.canvas.layers.find(x => x.id == layerId);
                            if(!!layer) {
                                layerOrder.push(layer);
                            }
                        });

                        $scope.canvas.layers.splice(0);
                        layerOrder.forEach( (layer) => {
                            $scope.canvas.layers.push(layer);
                        });

                        $scope.$apply();
                    }
                });

			}
		};

	}


}

angular.module('cpm')
    .directive('adSortableLayer', ['$rootScope', ($rootScope) => {
        'use strict';
        return new AdSortableLayer($rootScope);
    }]);
